export default () => {
    return {
        tagList: [{ label: 'News', value: 'News' }, { label: 'Blogs', value: 'Blogs' }]
    }
};